export default {
  getNetworkFeed: 'network/GET_NETWORK_FEED',
  getNetworkFeedSuccess: 'network/GET_NETWORK_FEED_SUCCESS',
  getNetworkFeedFailure: 'network/GET_NETWORK_FEED_FAILURE',

  removeNetworkFeedItem: 'network/REMOVE_NETWORK_FEED_ITEM',

  resolveNetworkShare: 'network/RESOLVE_NETWORK_SHARE',
  resolveNetworkShareSuccess: 'network/RESOLVE_NETWORK_SHARE_SUCCESS',
  resolveNetworkShareFailure: 'network/RESOLVE_NETWORK_SHARE_FAILURE',

  publishNetworkShare: 'network/PUBLISH_NETWORK_SHARE',
  publishNetworkShareSuccess: 'network/PUBLISH_NETWORK_SHARE_SUCCESS',
  publishNetworkShareFailure: 'network/PUBLISH_NETWORK_SHARE_FAILURE',

  withdrawNetworkShare: 'network/WITHDRAW_NETWORK_SHARE',
  withdrawNetworkShareSuccess: 'network/WITHDRAW_NETWORK_SHARE_SUCCESS',
  withdrawNetworkShareFailure: 'network/WITHDRAW_NETWORK_SHARE_FAILURE',

  getNetworkSettings: 'network/GET_NETWORK_SETTINGS',
  getNetworkSettingsSuccess: 'network/GET_NETWORK_SETTINGS_SUCCESS',
  getNetworkSettingsFailure: 'network/GET_NETWORK_SETTINGS_FAILURE',

  updateNetworkSettings: 'network/UPDATE_NETWORK_SETTINGS',
  updateNetworkSettingsSuccess: 'network/UPDATE_NETWORK_SETTINGS_SUCCESS',
  updateNetworkSettingsFailure: 'network/UPDATE_NETWORK_SETTINGS_FAILURE',

  getNetworkAutoPostCandidates: 'network/GET_NETWORK_AUTO_POST_CANDIDATES',
  getNetworkAutoPostCandidatesSuccess: 'network/GET_NETWORK_AUTO_POST_CANDIDATES_SUCCESS',
  getNetworkAutoPostCandidatesFailure: 'network/GET_NETWORK_AUTO_POST_CANDIDATES_FAILURE',
};
